import React from 'react';
import { ArrowUpRight, Github, Instagram, Twitter } from 'lucide-react';
import { siteData } from '../mock';

const iconMap = {
  Twitter,
  Instagram,
  Github
};

const Contact = () => {
  return (
    <section id="contact" className="relative overflow-hidden bg-gradient-to-b from-[#0d0d0d] to-black py-20 lg:py-32">
      <div className="grain-overlay opacity-20"></div>
      <div className="absolute left-0 top-10 h-72 w-72 rounded-full bg-pink-accent/10 blur-[120px]"></div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 lg:px-8">
        <div className="grid gap-6 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="rounded-[2rem] border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm lg:p-10">
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.28em] text-pink-accent">
              Contact
            </p>
            <h2 className="section-heading mb-6 text-left">{siteData.contact.title}</h2>
            <p className="mb-8 max-w-2xl text-base leading-8 text-white/70">
              {siteData.contact.blurb}
            </p>

            <div className="space-y-3">
              {siteData.contact.availability.map((item) => (
                <div key={item} className="flex items-start gap-3 rounded-2xl border border-white/8 bg-black/20 px-4 py-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-pink-accent"></span>
                  <span className="text-sm leading-7 text-white/75">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-[2rem] border border-white/10 bg-black/40 p-8 lg:p-10">
            <div className="mb-6 flex items-center justify-between border-b border-white/10 pb-5">
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/45">Links</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-pink-accent">best live channels</span>
            </div>

            <div className="space-y-4">
              {siteData.socials.map((social) => {
                const Icon = iconMap[social.icon];

                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center justify-between rounded-[1.35rem] border border-white/10 bg-white/[0.03] px-5 py-4 transition-all hover:border-pink-accent/40 hover:bg-white/[0.05]"
                  >
                    <div className="flex items-center gap-4">
                      <div className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-black/30 text-pink-accent">
                        <Icon size={18} />
                      </div>
                      <div>
                        <p className="font-medium text-white">{social.name}</p>
                        <p className="text-sm text-white/45">{social.url.replace('https://', '')}</p>
                      </div>
                    </div>
                    <ArrowUpRight size={18} className="text-white/35 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-pink-accent" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
